import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';

const STORAGE_KEY = 'pos24_order_actions';

export default class OrderSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            caption: '',
            commandName: '',
            commandValue: '',
            color: '#ffffff',
            foreground: '#000000',
            adminOnly: true,
            lockedOnly: false,
            newOrderOnly: false,
            actions: this.loadActions(),
            message: ''
        };
    }

    loadActions = () => {
        try {
            const raw = localStorage[STORAGE_KEY];
            return raw ? JSON.parse(raw) : [];
        } catch (e) {
            return [];
        }
    }

    saveActions = (actions) => {
        localStorage[STORAGE_KEY] = JSON.stringify(actions || []);
    }

    addAction = () => {
        const caption = (this.state.caption || '').trim();
        const commandName = (this.state.commandName || '').trim();
        const commandValue = (this.state.commandValue || '').trim();

        if (!caption || !commandName) {
            this.setState({ message: 'Buton adı ve command adı zorunludur.' });
            return;
        }

        const action = {
            caption: caption,
            commandName: commandName,
            commandValue: commandValue,
            color: (this.state.color || '#ffffff').trim(),
            foreground: (this.state.foreground || '#000000').trim(),
            adminOnly: this.state.adminOnly === true,
            lockedOnly: this.state.lockedOnly === true,
            newOrderOnly: this.state.newOrderOnly === true
        };

        const actions = this.state.actions.concat([action]);

        this.saveActions(actions);

        this.setState({
            actions: actions,
            caption: '',
            commandName: '',
            commandValue: 'Müşteri',
            color: '#ffffff',
            foreground: '#000000',
            adminOnly: true,
            lockedOnly: false,
            newOrderOnly: false,
            message: 'Sipariş hareketi eklendi.'
        });
    }

    removeAction = (index) => {
        const actions = this.state.actions.filter((x, i) => i !== index);

        this.saveActions(actions);

        this.setState({
            actions: actions,
            message: 'Sipariş hareketi kaldırıldı.'
        });
    }

    clearAll = () => {
        localStorage.removeItem(STORAGE_KEY);

        this.setState({
            actions: [],
            message: 'Tüm sipariş hareketi ayarları temizlendi.'
        });
    }

    goBack = () => {
        this.context.router.push('/login');
    }

    render() {
        return (
            <div style={{
                padding: '20px',
                height: '100vh',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '15px'
                }}>
                    <h4 style={{ margin: 0, fontWeight: '500' }}>
                        Sipariş Hareketleri
                    </h4>

                    <RaisedButton
                        label="Geri"
                        onClick={this.goBack}
                    />
                </div>

                <TextField
                    floatingLabelText="Buton Adı"
                    hintText="Örn: İkram"
                    value={this.state.caption}
                    onChange={(e) => this.setState({ caption: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Automation Command"
                    hintText="Örn: İkram / İade / Zayii"
                    value={this.state.commandName}
                    onChange={(e) => this.setState({ commandName: e.target.value })}
                    fullWidth={true}
                />

                <TextField
                    floatingLabelText="Command Value"
                    hintText="Örn: Müşteri / Yanlış Sipariş"
                    value={this.state.commandValue}
                    onChange={(e) => this.setState({ commandValue: e.target.value })}
                    fullWidth={true}
                />

                <div style={{ marginTop: '15px' }}>
                    <label>Buton Rengi</label>
                    <br />
                    <input
                        type="color"
                        value={this.state.color}
                        onChange={(e) => this.setState({ color: e.target.value })}
                        style={{ width: '80px', height: '36px' }}
                    />
                    <span style={{ marginLeft: '10px' }}>{this.state.color}</span>
                </div>

                <div style={{ marginTop: '15px' }}>
                    <label>Yazı Rengi</label>
                    <br />
                    <input
                        type="color"
                        value={this.state.foreground}
                        onChange={(e) => this.setState({ foreground: e.target.value })}
                        style={{ width: '80px', height: '36px' }}
                    />
                    <span style={{ marginLeft: '10px' }}>{this.state.foreground}</span>
                </div>

                <br />

                <Checkbox
                    label="Sadece Admin Kullanabilir"
                    checked={this.state.adminOnly}
                    onCheck={(e, checked) => this.setState({ adminOnly: checked })}
                />

                <Checkbox
                    label="Sadece Gönderilmiş Siparişte Görünsün"
                    checked={this.state.lockedOnly}
                    onCheck={(e, checked) => this.setState({ lockedOnly: checked, newOrderOnly: checked ? false : this.state.newOrderOnly })}
                />

                <Checkbox
                    label="Sadece Yeni Siparişte Görünsün"
                    checked={this.state.newOrderOnly}
                    onCheck={(e, checked) => this.setState({ newOrderOnly: checked, lockedOnly: checked ? false : this.state.lockedOnly })}
                />

                <br />

                <RaisedButton label="Listeye Ekle" primary={true} onClick={this.addAction} />
                {' '}
                <RaisedButton label="Tümünü Temizle" onClick={this.clearAll} />

                <br />
                <br />

                <div>{this.state.message}</div>

                <h4>Eklenen Sipariş Hareketleri</h4>

                {this.state.actions.length === 0 &&
                    <div>Henüz sipariş hareketi eklenmedi.</div>
                }

                {this.state.actions.map((action, index) =>
                    <div
                        key={index}
                        style={{
                            padding: '10px',
                            marginBottom: '8px',
                            border: '1px solid #ddd',
                            borderRadius: '4px'
                        }}
                    >
                        <div>
                            <b style={{ color: action.foreground }}>{action.caption}</b>
                        </div>
                        <div>Command: {action.commandName}</div>
                        <div>Value: {action.commandValue || '-'}</div>
                        <div>Admin: {action.adminOnly ? 'Evet' : 'Hayır'}</div>
                        <div>Gönderilmişte: {action.lockedOnly ? 'Evet' : 'Hayır'}</div>
                        <div>Yeni Siparişte: {action.newOrderOnly ? 'Evet' : 'Hayır'}</div>

                        <br />

                        <RaisedButton
                            label="Listeden Kaldır"
                            onClick={() => this.removeAction(index)}
                        />
                    </div>
                )}
            </div>
        );
    }
}

OrderSettings.contextTypes = {
    router: React.PropTypes.object
};


// WEBPACK FOOTER //
// ./app/components/OrderSettings.jsx